import { Badge } from '@art-of-hospitality-solutions-llc/ui-kit/components/badge';

export function FeatureOnOffBadge({ on }: { on: boolean }) {
  return on ? (
    <Badge variant="default">ON</Badge>
  ) : (
    <Badge variant="outline">OFF</Badge>
  );
}

export function VenueRollupBadge({
  onCount,
  spaceCount,
}: {
  onCount: number;
  spaceCount: number;
}) {
  const allOn = spaceCount > 0 && onCount === spaceCount;
  const partial = onCount > 0 && onCount < spaceCount;

  return (
    <div className="inline-flex items-center gap-2 whitespace-nowrap">
      {allOn ? (
        <Badge variant="default">ON</Badge>
      ) : partial ? (
        <Badge variant="secondary">PARTIAL</Badge>
      ) : (
        <Badge variant="outline">OFF</Badge>
      )}
      <span className="text-xs text-zinc-500 tabular-nums">
        {onCount}/{spaceCount}
      </span>
    </div>
  );
}
